import BookingSyncLogApiUrls from 'src/apiUrls/BookingSyncLogApiUrls'
import BookingSyncLogFormProperties from './BookingSyncLogFormProperties'
import React from 'react'
import { components } from 'cng-web-lib'

const {
  form: { CngAddForm }
} = components

function BookingSyncLogAddForm({
  history,
  showNotification,
  onPostSubmitSuccess
}) {
  return (
    <CngAddForm
      fieldLevel="toBeChangedByDeveloperIfWantFieldLevelRestriction"
      history={history}
      showNotification={showNotification}
      bodySection={
        <BookingSyncLogFormProperties.Fields
          showNotification={showNotification}
        />
      }
      formikProps={BookingSyncLogFormProperties.formikProps}
      toClientDataFormat={BookingSyncLogFormProperties.toClientDataFormat}
      toServerDataFormat={BookingSyncLogFormProperties.toServerDataFormat}
      create={{
        url: BookingSyncLogApiUrls.POST,
        onPostSubmitSuccess: onPostSubmitSuccess
      }}
    />
  )
}

export default BookingSyncLogAddForm
